import { render, staticRenderFns } from "./RemoteSign.vue?vue&type=template&id=ffda3cbc"
import script from "./RemoteSign.vue?vue&type=script&lang=js"
export * from "./RemoteSign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports